import React from "react";

const Footer = () => {
  return (
    <footer className="bg-white mt-6">
      <hr className="border-t border-gray-300 w-3/4 mx-auto" /> 
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl text-black font-bold mb-2 mt-8 text-center">
          EasySyntaxe
          <span className="block text-sm font-normal mt-2">
            by{" "}
            <a
              href="https://www.princekouame.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-black hover:text-gray-800"
            >
              Prince Kouamé
            </a>
          </span>
        </h1>
      </div>
    </footer>
  );
};

export default Footer;